import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type PromocodeItemDraft as SchemaPromocodeItemDraft } from '../schemas/PromocodeItemDraft';
import { type PromocodeItemWriteResponse as SchemaPromocodeItemWriteResponse } from '../schemas/PromocodeItemWriteResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Обновляет код промокода в указанной группе
 * @tags PromocodeGroups
 * @summary Обновление промокода в группе
 */
export const PromocodeGroupPromocodeUpdateContentType = 'application/json' as const;
export type PromocodeGroupPromocodeUpdateRequest = SchemaPromocodeItemDraft;
export type PromocodeGroupPromocodeUpdateResponses = LinkCommonErrorResponses & {
    /**
     * @description Запрос обработан
     */
    '200': {
        'application/json': SchemaPromocodeItemWriteResponse;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupPromocodeUpdateResponseSuccess =
    PromocodeGroupPromocodeUpdateResponses['200']['application/json'];
export type PromocodeGroupPromocodeUpdateSearchParams = undefined;
export type PromocodeGroupPromocodeUpdatePathParameters = {
    group_id: string;
    promocode_id: string;
};
export const PromocodeGroupPromocodeUpdateUrl = '/promocode_groups/{group_id}/promocodes/{promocode_id}' as const;
export const PromocodeGroupPromocodeUpdateMethod = 'PATCH' as const;
export const getPromocodeGroupPromocodeUpdateUrl = (params: PromocodeGroupPromocodeUpdatePathParameters) =>
    PromocodeGroupPromocodeUpdateUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupPromocodeUpdatePathParameters) => String(params[param])
    );
